import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../models/restResponse.mode';
import { Brand } from '../../models/brand.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private readonly baseUrl = `${environment.base_url}/brands`;

  constructor(private http: HttpClient) {}

  getAll(description: string, active: boolean | null, paginate: boolean, page: number | null): Observable<RestResponse<Brand[]>> {
    return this.http.get<RestResponse<Brand[]>>(`${this.baseUrl}/list?search=${description}&active=${active}&paginate=${paginate}&page=${page}`);
  }

  getById(id: number): Observable<RestResponse<Brand>> {
    return this.http.get<RestResponse<Brand>>(`${this.baseUrl}/find/${id}`);
  }

  create(brand: Brand): Observable<Brand> {
    return this.http.post<Brand>(`${this.baseUrl}/save`, brand);
  }

  update(id: number, brand: Brand): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, brand);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

}
